import { Tag } from 'foundations-components/transitional/components/Tag';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';

//UIBadge does not except same use props as the tags, only colors
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function convertColor(use) {
  switch (use) {
    default:
    case 'disabled':
    case 'draft':
    case 'default':
      return 'koala';
    case 'published':
    case 'success':
    case 'active':
    case 'info':
      return 'oz';
    case 'cancelled':
    case 'danger':
      return 'candy-apple';
    case 'scheduled':
      return 'marigold';
    case 'thunderdome':
      return 'thunderdome';
  }
}
export default function StatusTagComponent({
  use,
  useComponent,
  children
}) {
  switch (useComponent) {
    default:
      return /*#__PURE__*/_jsx(StatusTag, {
        "data-test-id": "status-property-status-tag",
        use: use,
        children: children
      });
    case 'UIBadge':
    case 'Badge':
      return /*#__PURE__*/_jsx(Badge, {
        "data-test-id": "status-property-badge",
        use: convertColor(use),
        children: children
      });
    case 'UITag':
      return /*#__PURE__*/_jsx(Tag, {
        "data-test-id": "status-property-tag",
        use: use,
        children: children
      });
    case 'UIHollowDot':
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(StatusDot, {
          "data-test-id": "status-property-hollow-dot",
          use: use,
          hollow: true
        }), children]
      });
  }
}